import React from 'react';
import { Row, Col } from 'react-bootstrap';

const Header = ({ page }) => {

  return (
    <div className='header'>
      <Row>
        <Col>
          <p className="text-uppercase text-muted mb-1" style={{ fontSize: '0.75rem' }}>
            Gerenciamento
          </p>
          <h4 className="mb-2">
            {page ? page.toUpperCase() : '--'}
          </h4>
        </Col>
      </Row>
    </div>
  );
};

export default Header;
